import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=3a2e6a5c&scoped=true&"
import script from "./NotificationContent.vue?vue&type=script&lang=js&"
export * from "./NotificationContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=3a2e6a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e6a5c",
  null
  
)

export default component.exports